const state = {
    workorderHistoryCodeInformationFields: [
        // {
        //     key: "code",
        //     label: "工單編號",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // },
        {
            key: "work_org_code",
            label: "工單編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "productCode",
            label: "料號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "control_card",
            label: "管制卡號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "product_chinese_name",
            label: "料名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "mould_code",
            label: "模具編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "work_qty",
            label: "派工支數",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standard_total_weight",
            label: "生產總重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    workorderHistoryCodeInformationItem: [],
}
const getters = {
    get_workorderHistoryCodeInformationFields: state => {
        return state.workorderHistoryCodeInformationFields
    },
    get_workorderHistoryCodeInformationItem: state => {
        return state.workorderHistoryCodeInformationItem
    },
}
const actions = {
    set_workorderHistoryCodeInformationFields(context, array) {
        context.commit('SET_WORKORDERHISTORYCODEINFORMATIONFIELDS', array);
    },
    set_workorderHistoryCodeInformationItem(context, array) {
        context.commit('SET_WORKORDERHISTORYCODEINFORMATIONITEM', array);
    },
    clear_workorderHistoryCodeInformationItem(context) {
        context.commit('CLEAR_WORKORDERHISTORYCODEINFORMATIONITEM');
    },
}
const mutations = {
    SET_WORKORDERHISTORYCODEINFORMATIONFIELDS(state, array) {
        state.workorderHistoryCodeInformationFields = array;
    },
    SET_WORKORDERHISTORYCODEINFORMATIONITEM(state, array) {
        state.workorderHistoryCodeInformationItem = array;
    },
    CLEAR_WORKORDERHISTORYCODEINFORMATIONITEM(state) {
        state.workorderHistoryCodeInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorderHistoryCodeInformation.js